import React from "react";
import { useSelector } from "react-redux";
import "../style/Sidebar.css";
import Fournisseurs from "../images/fournisseurs.png";
import Lentilles from "../images/lentilles.png";
import LogoTransparent from "../images/logo-transparent.png";
import Marques from "../images/marques.png";
import Mutuelles from "../images/mutuelles.png";
import Verres from "../images/verres.png";
import { Link } from "react-router-dom";

function Sidebar() {
  const isAdmin = useSelector((state) => state.role);

  return (
    <div className="menu">
      <Link to={isAdmin ? "/backoffice/home" : "/"} className="sidebarLogo">
        <img src={LogoTransparent} alt="Logo Monocle" className="sidebarLogo" />
      </Link>
      <Link
        to={isAdmin ? "/liste-marques-admin" : "/magasin/marques"}
        className="sidebarItem"
      >
        <img src={Marques} alt="marques de lunettes" className="sidebarImg" />
        Mes marques
      </Link>
      <Link
        to={isAdmin ? "/liste-fournisseurs-montures" : "/fournisseurs-montures"}
        className="sidebarItem"
      >
        <img
          src={Fournisseurs}
          alt="usine de lunettes"
          className="sidebarImg"
        />
        Fournisseurs
      </Link>
      <Link
        to={isAdmin ? "/liste-fournisseurs-verres" : "/fournisseurs-verres"}
        className="sidebarItem"
      >
        <img src={Verres} alt="verre" className="sidebarImg" />
        Verriers
      </Link>
      <Link
        to={
          isAdmin ? "/liste-fournisseurs-lentilles" : "/fournisseurs-lentilles"
        }
        className="sidebarItem"
      >
        <img src={Lentilles} alt="lentille" className="sidebarImg" />
        Lentilles
      </Link>
      <Link
        to={isAdmin ? "/liste-mutuelles-admin" : "/mutuelles"}
        className="sidebarItem"
      >
        <img src={Mutuelles} alt="mutuelle" className="sidebarImg" />
        Mutuelles
      </Link>
      <Link to={"/mentions"} className="sidebarMentions">
        Mentions légales
      </Link>
    </div>
  );
}

export default Sidebar;
